/* eslint-disable react/prop-types */

import React, { useState } from "react";

import {
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  Card,
  Select,
  Box,
  CardContent,
} from "@material-ui/core";
import Item from "../ToolbarMenu/Item";
import { useRouter } from "../../util";
import { parseStringParam } from "/lib/util/params";

const TERMINAL_VIEWS = [
  {
    name: "Window_id_panel",
    panelId: "15",
    width: 550,
  },
  {
    name: "Bet_count_by_terminal",
    panelId: "13",
    width: 550,
  },
  {
    name: "Bet_placed_by_terminal",
    panelId: "14",
    width: 550,
  },
  {
    name: "terminal_printer_status",
    panelId: "18",
    width: 550,
  },
  {
    name: "terminal_hardware_health",
    panelId: "19",
    width: 1110,
    height: 350,
  },
  {
    name: "terminal_bet_distribution",
    panelId: "12",
    width: 1110,
    height: 350,
  },
];

interface PanelProps {
  //panel id from Grafana
  panelId: string;
  //time from&to (please use Grafana time format)
  from?: string;
  to?: string;
  //set refresh rate, default to 1m
  refreshInterval?: string;
  //set Entity name by selector
  entity?: string; // default to first one after query entities
  width?: number;
  height?: number;
}

const MetricPanel: React.FC<PanelProps> = ({
  panelId,
  from = "now-1h",
  to = "now",
  refreshInterval = "5m",
  entity,
  width,
  height,
}) => {
  const BASEURL =
    "https://onemetrics-dashboard.hardware-inno.gcpprodau.tbm.sh/d-solo/ca9198a7-5e13-4cc5-821f-a81034b1e1a9/onewatch-metrics-dashboard?orgId=1";
  const router = useRouter();
  const namespace = parseStringParam(
    (router.match.params as any).namespace,
    "",
  );
  const url = `${BASEURL}&var-namespace=${namespace}&var-Entity=${entity}&from=${from}&to=${to}&panelId=${panelId}&refresh=${refreshInterval}`;

  return (
    <Item>
      <iframe
        title="Grafana-panel"
        src={url}
        width={width}
        height={height || 250}
      />
    </Item>
  );
};

const EntityMetrics = ({ entity }: { entity: string }) => {
  const [timeRange, setTimeRange] = useState("-1d");
  const handleTimeChange = (event: any) => {
    setTimeRange(event.target.value);
  };

  const TimeSelector = () => {
    return (
      <Box component="section" width={600}>
        <FormControl fullWidth>
          <InputLabel id="time-selector">Select time Range</InputLabel>
          <Select
            labelId="time-selector"
            id="time-selector"
            value={timeRange}
            label="Time Range"
            onChange={handleTimeChange}
          >
            {/* <MenuItem value="-5m">Last 5 minutes</MenuItem> */}
            <MenuItem value="-15m">Last 15 minutes</MenuItem>
            <MenuItem value="-30m">Last 30 minutes</MenuItem>
            <MenuItem value="-1h">Last 1 hour</MenuItem>
            <MenuItem value="-3h">Last 3 hours</MenuItem>
            <MenuItem value="-6h">Last 6 hours</MenuItem>
            <MenuItem value="-12h">Last 12 hours</MenuItem>
            <MenuItem value="-1d">Last 1 day</MenuItem>
            {/* <MenuItem value="-3d">Last 3 days</MenuItem>
                      <MenuItem value="-7d">Last week</MenuItem>
                      <MenuItem value="-30d">Last month</MenuItem> */}
          </Select>
        </FormControl>
      </Box>
    );
  };

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <TimeSelector />
          </Grid>
          <Box
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {TERMINAL_VIEWS.map((view, index) => (
              <MetricPanel
                panelId={view.panelId}
                from={`now${timeRange}`}
                to="now"
                width={view.width || 400}
                height={view.height || 200}
                entity={entity}
                key={index}
              />
            ))}
          </Box>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default EntityMetrics;
